import { PinService } from "@/api";

// state
const state = () => ({
  all: [],
});

// getters
const getters = {};

// actions
const actions = {
  async getAll({ commit }) {
    const resp = await PinService.getAll();
    const { pin } = resp;

    commit("setAll", pin);
  },
};

// mutations
const mutations = {
  setAll(state, pin) {
    state.all = pin;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
